<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.fmtName" style="width: 100px;" size="small" placeholder="讲师姓名"
                        clearable></el-input>
                    <el-input v-model="formDatas.fmtIdcard" style="width: 140px;" size="small" placeholder="身份证号"
                        clearable></el-input>
                    <el-select size="small" v-model="formDatas.fmtCooperateType" clearable @change="partserch"
                        placeholder="合作方式" style="width: 100px">
                        <el-option label="签约讲师" value="签约讲师" key="签约讲师"></el-option>
                        <el-option label="外部讲师" value="外部讲师" key="外部讲师"></el-option>
                        <el-option label="内部讲师" value="内部讲师" key="内部讲师"></el-option>
                        <el-option label="内部员工" value="内部员工" key="内部员工"></el-option>
                    </el-select>
                    <el-select size="small" v-model="formDatas.syncStatus" clearable @change="partserch"
                        placeholder="每刻同步" style="width: 100px">
                        <el-option label="是" :value="2" key="2"></el-option>
                        <el-option label="否" :value="1" key="1"></el-option>
                        <el-option label="失败" :value="3" key="3"></el-option>
                        <el-option label="不需要" :value="4" key="4"></el-option>
                    </el-select>
                    <el-select size="small" v-model="formDatas.syncStatusZaitu" clearable @change="partserch"
                        placeholder="在途同步" style="width: 100px">
                        <el-option label="是" :value="2" key="2"></el-option>
                        <el-option label="否" :value="1" key="1"></el-option>
                        <el-option label="失败" :value="3" key="3"></el-option>
                        <el-option label="不需要" :value="4" key="4"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.syncStatusInit" clearable @change="partserch"
                        placeholder="初始化数据需要同步" style="width: 170px">
                        <el-option label="不需要" :value="2" key="2"></el-option>
                        <el-option label="需要" :value="1" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="warning" size="mini" style="margin-left: 10px;"
                        @click="BatchDisable">批量删除</el-button>
                </el-row>
            </div>
            <!-- <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="warning" size="small" style="margin-right: 10px;"
                        @click="FXXKuser">全量同步纷享销客用户</el-button>
                </el-row>
            </div> -->
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="fmtId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { getFxxkMeikeTeacherList,updateFxxkMeikeTeacherNotSync } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            props: {
                value: 'id',
                label: 'name',
                children: 'child',
            },
            departmentArr: [],
            dialog: false,
            edit: false,
            form: {
                aacName: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: false,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 20,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "fmtName",
                    key: "fmtName",
                    title: "讲师姓名",
                    align: "center",
                },
                {
                    field: "fmtNameSub",
                    key: "fmtNameSub",
                    title: "讲师授课名",
                    align: "center",
                },
                {
                    field: "fmtIdcard",
                    key: "fmtIdcard",
                    title: "身份证号",
                    align: "center",
                },
                {
                    field: "fmtPhone",
                    key: "fmtPhone",
                    title: "联系方式",
                    align: "center",
                },
                {
                    field: "fmtCooperateType",
                    key: "fmtCooperateType",
                    title: "合作方式",
                    align: "center",
                },
                {
                    field: "fmtEmail",
                    key: "fmtEmail",
                    title: "邮箱",
                    align: "center",
                },
                {
                    field: "fmtEmailRandom",
                    key: "fmtEmailRandom",
                    title: "邮箱随机",
                    align: "center",
                },
                {
                    field: "fmtAccount",
                    key: "fmtAccount",
                    title: "同步的账号",
                    align: "center",
                },
                {
                    field: "syncStatus",
                    key: "syncStatus",
                    title: "每刻同步",
                    align: "center",
                },
                {
                    field: "syncStatusZaitu",
                    key: "syncStatusZaitu",
                    title: "在途同步",
                    align: "center",
                },
                {
                    field: "syncStatusFailMsg",
                    key: "syncStatusFailMsg",
                    title: "同步失败信息",
                    align: "center",
                },
                {
                    field: "syncStatusInit",
                    key: "syncStatusInit",
                    title: "初始化数据",
                    width: 90,
                    fixed: 'right',
                    align: "center",
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                fmtCooperateType: "",
                syncStatusInit: "",
                syncStatus:2,
                syncStatusZaitu: "",
                fmtName: "",
                fmtIdcard: "",
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();

    },
    mounted() { },
    methods: {
          openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        BatchDisable() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    type: "warning",
                    message: "请至少选择一行数据!",
                });
                return;
            }
            this.$confirm("是否批量删除", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.openLoading();
                updateFxxkMeikeTeacherNotSync({ fmtIds: JSON.stringify(this.selectedRowKeysCollection) }).then((res) => {
                    this.selectedRowKeysCollection = [];
                    this.checkboxOption.selectedRowKeys = [];
                    this.partserch();
                    this.loadings.close();
                    // this.$message({
                    //   type: "success",
                    //   message: "搜索成功!",
                    // });
                });
            }).catch(() => { });
        },
        FXXKuser() {
            updateSyncFxxkMeikeUserAll().then(res => {
                if (res) {
                    this.$message({
                        type: "success",
                        message: "获取成功!",
                    });
                }
            })
        },


        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys() {
            console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item.fmtId) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item.fmtId);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys) {
            console.log(isSelected, selectedRowKeys);
            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item.fmtId) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.fmtId), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected) {
            const rowKey = row.fmtId;

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getFxxkMeikeTeacherList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();

            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getFxxkMeikeTeacherList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys();

            });
        },
        getList() {
            getFxxkMeikeTeacherList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body .ve-table-expand-tr .ve-table-expand-td-content {
    padding: 0 !important;
}
</style>